<div class="set-campaign-dialog">
  <div class="set-campaign-dialog-header flex-between-center">
    <p class="m-0 font-bold">
      {{header}}
    </p>
    <span class="close-modal">
      <i class="fal fa-times" (click)="handleClose()"></i>
    </span>
  </div>

  <div class="set-campaign-dialog-body flex-column flex-wrap flex-start-start">
    <div class="ui-g-12 p-0">
      <div class="ui-g-6 py-0 pl-0">
        <div class="secondary-input-theme pointer">
          <label class="mb-0 font-11 font-gray-45 w-100">Date</label>
          <p-calendar [minDate]="min" id="payment-date" placeholder="Date" styleClass="payment-pointer" panelStyleClass="sticker-calendar-panel"
            (onSelect)="onSelectStartDate($event);" appendTo="body" [(ngModel)]="date" [readonlyInput]="false" dateFormat="M d, yy"
            #paymentDateTimeEl></p-calendar>
          <i class="fal fa-calendar-alt font-12 font-gray-75" (click)="paymentDateTimeEl.showOverlay()"></i>
        </div>
      </div>
      <div class="ui-g-6 py-0 pr-0">
        <div class="secondary-input-theme time">
          <label class="mb-0 font-11 font-gray-45 w-100">Time</label>
          <kendo-timepicker [(value)]="time" [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
          </kendo-timepicker>
        </div>
      </div>
    </div>
  </div>

  <div class="set-campaign-dialog-footer flex-end-center">
    <button class="btn btn-border pointer btn-submit mr-1" (click)="handleClose()">Cancel</button>
    <button class="btn btn-primary btn-submit" (click)="handleSave(true)">
      Save
    </button>
  </div>
</div>
